export default "__VITE_ASSET__BG1Aq3NW__"